import { get, put,Delete,post } from '../axios'

// 故障录波-列表
export const recordList = params => get(`/web/fault/record/list`,params);

// 故障录波-详情
export const recordView = params => get(`/web/fault/record/view/`+params, '');

// 故障录波-读取故障录波
export const recordUpdateFaultRecord = params => put(`/web/fault/record/updateFaultRecord`,params);


